import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a320993"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Photos", -1))
const _hoisted_3 = {
  key: 1,
  ref: "dropZoneRef",
  class: "item-wrapper-grid"
}
const _hoisted_4 = {
  key: 0,
  class: "drop-zone"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-zone__body" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "drop-zone__icon icon icon-download" }),
  /*#__PURE__*/_createElementVNode("span", { class: "drop-zone__text" }, "Drop some files here")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Photos", -1))
const _hoisted_10 = {
  key: 0,
  ref: "dropZoneRef",
  class: "item-wrapper-grid"
}
const _hoisted_11 = {
  key: 0,
  class: "drop-zone"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-zone__body" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "drop-zone__icon icon icon-download" }),
  /*#__PURE__*/_createElementVNode("span", { class: "drop-zone__text" }, "Drop some files here")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus" }, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "no-photo-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header_upload_progress = _resolveComponent("app-header-upload-progress")!
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_upload_photos_pop_up = _resolveComponent("upload-photos-pop-up")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.mainStore.uploadInfos.length)
          ? (_openBlock(), _createBlock(_component_app_header_upload_progress, {
              key: 0,
              uploadInfo: _ctx.mainStore.getUploadInfo
            }, null, 8, ["uploadInfo"]))
          : _createCommentVNode("", true),
        _hoisted_2,
        (_ctx.photos.length || _ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (!_ctx.dataLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.isOverDropZone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoSkeletons, (n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item-grid file-box",
                        key: n
                      }, [
                        _createVNode(_component_app_skeleton_rect)
                      ]))
                    }), 128)),
                    (!_ctx.driveStore.currentCase.photos.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          ref: "fileInputButton",
                          class: "file-button caseItem item-grid",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopUp && _ctx.openPopUp(...args)))
                        }, [
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(_ctx.$localize('drive.file.type.photo')), 1)
                        ], 512))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.driveStore.currentCase.photos, (photo) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: photo.id + photo.fileUrl,
                            class: "item-grid"
                          }, [
                            _createVNode(_component_item_photo, {
                              photo: photo,
                              selector: _ctx.selector || _ctx.driveStore.isPhotoSelector,
                              "column-view": _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST
                            }, null, 8, ["photo", "selector", "column-view"])
                          ]))
                        }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isPageLoading || _ctx.dataLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(27, (n) => {
                    return _createElementVNode("div", {
                      key: n,
                      class: _normalizeClass(["item-grid caseItem", { 'item-grid': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID }])
                    }, [
                      _createVNode(_component_app_skeleton_rect)
                    ], 2)
                  }), 64))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_app_no_message, {
          icon: _ctx.noPhotosMessage.icon
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.noPhotosMessage.text), 1)
          ]),
          _: 1
        }, 8, ["icon"]), [
          [_vShow, !_ctx.dataLoading && _ctx.noPhotosMessage && !_ctx.driveStore.photos.data]
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _hoisted_9,
        (_ctx.photos.length || _ctx.dataLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (!_ctx.dataLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.isOverDropZone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoSkeletons, (n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "item-grid file-box",
                        key: n
                      }, [
                        _createVNode(_component_app_skeleton_rect)
                      ]))
                    }), 128)),
                    (!_ctx.driveStore.currentCase.photos.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (!_ctx.isPreviewCasePhotos)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                ref: "fileInputButton",
                                class: "file-button caseItem item-grid",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDesktopPopUp && _ctx.openDesktopPopUp(...args)))
                              }, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(_ctx.$localize('drive.file.type.photo')), 1)
                              ], 512))
                            : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$localize('shared.case.photos.overview.no.photos')), 1))
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.driveStore.currentCase.photos, (photo) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: photo.id + photo.fileUrl,
                            class: "item-grid"
                          }, [
                            _createVNode(_component_item_photo, {
                              photo: photo,
                              selector: _ctx.selector || _ctx.driveStore.isPhotoSelector,
                              blockGrid: ""
                            }, null, 8, ["photo", "selector"])
                          ]))
                        }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isPageLoading || _ctx.dataLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(27, (n) => {
                    return _createElementVNode("div", {
                      key: n,
                      class: _normalizeClass(["item-grid caseItem", { 'item-grid': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID }])
                    }, [
                      _createVNode(_component_app_skeleton_rect)
                    ], 2)
                  }), 64))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true),
        (_ctx.showPopUp)
          ? (_openBlock(), _createBlock(_component_upload_photos_pop_up, {
              key: 1,
              onClose: _ctx.hidePopUp,
              "photos-pop-up-pos": _ctx.photosPopUpPos
            }, null, 8, ["onClose", "photos-pop-up-pos"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_app_no_message, {
          icon: _ctx.noPhotosMessage.icon
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.noPhotosMessage.text), 1)
          ]),
          _: 1
        }, 8, ["icon"]), [
          [_vShow, !_ctx.dataLoading && _ctx.noPhotosMessage && !_ctx.driveStore.photos.data]
        ])
      ]))
}